import { useState, useEffect, FormEvent } from 'react';
import { Link } from 'react-router-dom';
import Navigation from '../../home/components/Navigation';
import Footer from '../../home/components/Footer';

export default function LadySPage() {
  const images = [
    'https://images.northropandjohnson.com/yacht/Z6Cbuu7aqm/5ed5cd0dcc8ada3943f0725f/CCB8CF66.jpg?auto=format&q=65&w=1920',
    'https://images.northropandjohnson.com/yacht/Z6Cbuu7aqm/5ed5cd0dcc8ada3943f0725f/C50F00DA.jpg?auto=format&q=65&w=1920',
    'https://images.northropandjohnson.com/yacht/Z6Cbuu7aqm/5ed5cd0dcc8ada3943f0725f/EC2C1E80.jpg?auto=format&q=65&w=1920',
    'https://images.northropandjohnson.com/yacht/Z6Cbuu7aqm/5ed5cd0dcc8ada3943f0725f/CE269D3D.jpg?auto=format&q=65&w=1920',
    'https://images.northropandjohnson.com/yacht/Z6Cbuu7aqm/5ed5cd0dcc8ada3943f0725f/F7837688.jpg?auto=format&q=65&w=1920',
    'https://images.northropandjohnson.com/yacht/Z6Cbuu7aqm/5ed5cd0dcc8ada3943f0725f/B3C44294.jpg?auto=format&q=65&w=1920',
    'https://images.northropandjohnson.com/yacht/Z6Cbuu7aqm/5ed5cd0dcc8ada3943f0725f/8D0E1F3E.jpg?auto=format&q=65&w=1920',
    'https://images.northropandjohnson.com/yacht/Z6Cbuu7aqm/5ed5cd0dcc8ada3943f0725f/D4E5A2B9.jpg?auto=format&q=65&w=1920',
    'https://images.northropandjohnson.com/yacht/Z6Cbuu7aqm/5ed5cd0dcc8ada3943f0725f/A1F8C7D2.jpg?auto=format&q=65&w=1920',
    'https://images.northropandjohnson.com/yacht/Z6Cbuu7aqm/5ed5cd0dcc8ada3943f0725f/E9B3D4F1.jpg?auto=format&q=65&w=1920'
  ];

  const [currentImage, setCurrentImage] = useState(0);
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    preferredDates: '',
    destination: '',
    guests: '',
    message: ''
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState<'idle' | 'success' | 'error'>('idle');

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const nextImage = () => {
    setCurrentImage((prev) => (prev + 1) % images.length);
  };

  const prevImage = () => {
    setCurrentImage((prev) => (prev - 1 + images.length) % images.length);
  };

  const scrollToInquiry = () => {
    document.getElementById('inquiry-form')?.scrollIntoView({ behavior: 'smooth' });
  };

  const handleSubmit = async (e: FormEvent) => {
    e.preventDefault();
    setIsSubmitting(true);

    try {
      const response = await fetch('https://readdy.ai/api/form/d5l8pfadeasqilubg430', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: new URLSearchParams({
          yacht: 'LADY S',
          name: formData.name,
          email: formData.email,
          phone: formData.phone,
          preferredDates: formData.preferredDates,
          destination: formData.destination,
          guests: formData.guests,
          message: formData.message
        }).toString()
      });

      if (response.ok) {
        setSubmitStatus('success');
        setFormData({
          name: '',
          email: '',
          phone: '',
          preferredDates: '',
          destination: '',
          guests: '',
          message: ''
        });
        setTimeout(() => {
          setSubmitStatus('idle');
        }, 3000);
      } else {
        setSubmitStatus('error');
      }
    } catch (error) {
      console.error('Form submission error:', error);
      setSubmitStatus('error');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="min-h-screen bg-white">
      <Navigation />

      {/* Hero Image Gallery */}
      <section className="relative h-screen mt-20">
        <div className="absolute inset-0">
          <img
            src={images[currentImage]}
            alt="Lady S Superyacht"
            className="w-full h-full object-cover"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-black/20 to-transparent"></div>
        </div>

        {/* Navigation Arrows */}
        <button
          onClick={prevImage}
          className="absolute left-6 top-1/2 -translate-y-1/2 w-14 h-14 bg-white/90 hover:bg-white rounded-full flex items-center justify-center transition-all z-10 cursor-pointer"
        >
          <i className="ri-arrow-left-s-line text-2xl"></i>
        </button>
        <button
          onClick={nextImage}
          className="absolute right-6 top-1/2 -translate-y-1/2 w-14 h-14 bg-white/90 hover:bg-white rounded-full flex items-center justify-center transition-all z-10 cursor-pointer"
        >
          <i className="ri-arrow-right-s-line text-2xl"></i>
        </button>

        {/* Image Counter */}
        <div className="absolute bottom-8 left-1/2 -translate-x-1/2 bg-black/60 text-white px-4 py-2 rounded-full text-sm">
          {currentImage + 1} / {images.length}
        </div>

        {/* Yacht Title Overlay */}
        <div className="absolute bottom-0 left-0 right-0 p-12 text-white z-10">
          <div className="max-w-7xl mx-auto">
            <h1 className="text-6xl font-bold mb-4">LADY S</h1>
            <div className="flex items-center gap-8 text-lg mb-6">
              <span>Feadship 2019</span>
              <span>•</span>
              <span>93m / 305ft</span>
              <span>•</span>
              <span>12 Guests</span>
              <span>•</span>
              <span>31 Crew</span>
            </div>
            <button
              onClick={scrollToInquiry}
              className="bg-teal-500 hover:bg-teal-600 text-white px-8 py-4 rounded-lg text-lg font-semibold transition-all whitespace-nowrap cursor-pointer"
            >
              Request Charter Information
            </button>
          </div>
        </div>
      </section>

      {/* Quick Specs Bar */}
      <section className="bg-gray-50 py-8 border-b">
        <div className="max-w-7xl mx-auto px-6">
          <div className="grid grid-cols-2 md:grid-cols-4 gap-6">
            <div className="text-center">
              <div className="text-3xl font-bold text-teal-600 mb-2">€1,750,000</div>
              <div className="text-sm text-gray-600">Per Week (Summer)</div>
            </div>
            <div className="text-center">
              <div className="text-3xl font-bold text-teal-600 mb-2">€1,600,000</div>
              <div className="text-sm text-gray-600">Per Week (Winter)</div>
            </div>
            <div className="text-center">
              <div className="text-3xl font-bold text-teal-600 mb-2">12</div>
              <div className="text-sm text-gray-600">Maximum Guests</div>
            </div>
            <div className="text-center">
              <div className="text-3xl font-bold text-teal-600 mb-2">7</div>
              <div className="text-sm text-gray-600">Luxurious Cabins</div>
            </div>
          </div>
        </div>
      </section>

      {/* Main Content */}
      <section className="py-20">
        <div className="max-w-7xl mx-auto px-6">
          <div className="grid lg:grid-cols-3 gap-12">
            {/* Left Column - Main Info */}
            <div className="lg:col-span-2 space-y-12">
              {/* Overview */}
              <div>
                <h2 className="text-4xl font-bold mb-6">Overview</h2>
                <div className="prose prose-lg max-w-none text-gray-700 leading-relaxed space-y-4">
                  <p>
                    The 305-foot (93m) Feadship LADY S is an impeccable luxury charter yacht with fantastic amenities and stunning aesthetics. From the IMAX Dolby cinema (the first of its kind) to the basketball court, she boasts multiple entertainment opportunities for the ultimate charter experience. Incorporating stunning exterior lines by De Voogt Naval Architects and a sophisticated Reymond Langton Design interior, she has already earned herself an impressive reputation following her successful debut on the charter market.
                  </p>
                  <p>
                    LADY S has literally dozens of standout features, including a commercially certified helipad, oversized spa with Hammam and ice-plunge pool, a glass-bottomed pool, nightclub with interactive dancefloor, firepits, outdoor cinema/IMAX Dolby Cinema, basketball court, golf tee and simulator, and gym.
                  </p>
                  <p>
                    LADY S boasts a stunning interior décor that has been timelessly styled with beautiful custom furniture and sumptuous soft furnishings for the ultimate in comfort and relaxation. The complex, multi-layered interior design combines elegance with a fully-functional layout for charter. A perfect example of this is the largely white and light color palette, which, through a careful selection of materials, can be flexible and well suited for charter use.
                  </p>
                  <p>
                    Designed with charter and private cruising in mind, LADY S has a variety of shaded areas, and large open areas for entertainment. It is the exterior entertainment spaces that truly set her apart from the rest of the fleet. Described as "very livable", every area has been created for total relaxation – from her beach club to pool deck with glass bottom swimming pool, the choices are endless.
                  </p>
                </div>
              </div>

              {/* Specifications */}
              <div>
                <h2 className="text-4xl font-bold mb-6">Specifications</h2>
                <div className="grid md:grid-cols-2 gap-6">
                  <div className="bg-gray-50 p-6 rounded-lg">
                    <div className="text-sm text-gray-600 mb-1">Length</div>
                    <div className="text-xl font-semibold">93 Meters / 305 Feet</div>
                  </div>
                  <div className="bg-gray-50 p-6 rounded-lg">
                    <div className="text-sm text-gray-600 mb-1">Builder</div>
                    <div className="text-xl font-semibold">Feadship</div>
                  </div>
                  <div className="bg-gray-50 p-6 rounded-lg">
                    <div className="text-sm text-gray-600 mb-1">Year Built</div>
                    <div className="text-xl font-semibold">2019</div>
                  </div>
                  <div className="bg-gray-50 p-6 rounded-lg">
                    <div className="text-sm text-gray-600 mb-1">Guests</div>
                    <div className="text-xl font-semibold">12</div>
                  </div>
                  <div className="bg-gray-50 p-6 rounded-lg">
                    <div className="text-sm text-gray-600 mb-1">Cabins</div>
                    <div className="text-xl font-semibold">7</div>
                  </div>
                  <div className="bg-gray-50 p-6 rounded-lg">
                    <div className="text-sm text-gray-600 mb-1">Crew</div>
                    <div className="text-xl font-semibold">31</div>
                  </div>
                  <div className="bg-gray-50 p-6 rounded-lg">
                    <div className="text-sm text-gray-600 mb-1">Hull Type</div>
                    <div className="text-xl font-semibold">Motor Yacht</div>
                  </div>
                  <div className="bg-gray-50 p-6 rounded-lg">
                    <div className="text-sm text-gray-600 mb-1">Naval Architect</div>
                    <div className="text-xl font-semibold">De Voogt</div>
                  </div>
                  <div className="bg-gray-50 p-6 rounded-lg">
                    <div className="text-sm text-gray-600 mb-1">Interior Designer</div>
                    <div className="text-xl font-semibold">Reymond Langton</div>
                  </div>
                  <div className="bg-gray-50 p-6 rounded-lg">
                    <div className="text-sm text-gray-600 mb-1">Flag</div>
                    <div className="text-xl font-semibold">Cayman Islands</div>
                  </div>
                </div>
              </div>

              {/* Accommodation */}
              <div>
                <h2 className="text-4xl font-bold mb-6">Accommodation</h2>
                <div className="bg-gray-50 p-8 rounded-lg">
                  <div className="flex items-center gap-4 mb-6">
                    <div className="w-16 h-16 bg-teal-500 rounded-full flex items-center justify-center">
                      <i className="ri-user-line text-3xl text-white"></i>
                    </div>
                    <div>
                      <div className="text-2xl font-bold">12 Guests</div>
                      <div className="text-gray-600">Maximum Capacity</div>
                    </div>
                  </div>
                  <div className="space-y-4 text-gray-700">
                    <p className="leading-relaxed">
                      LADY S accommodates up to 12 guests in 7 spacious staterooms, including a large master suite, four VIP staterooms and two twins. All the latest, state-of-the-art entertainment and communications equipment can be found on board and throughout her accommodation.
                    </p>
                    <p className="leading-relaxed">
                      The master suite is a private sanctuary featuring panoramic windows, a king-size bed, walk-in wardrobes, and a luxurious marble bathroom. Each VIP and guest cabin is finished to the highest standards with premium fabrics, sophisticated lighting, and entertainment systems.
                    </p>
                  </div>
                </div>
              </div>

              {/* Highlights */}
              <div>
                <h2 className="text-4xl font-bold mb-6">Highlights</h2>
                <div className="grid md:grid-cols-2 gap-4">
                  <div className="bg-gray-50 p-6 rounded-lg flex items-start gap-4">
                    <i className="ri-check-line text-2xl text-teal-600 mt-1"></i>
                    <div>
                      <div className="font-semibold mb-1">Heated Jacuzzi Pool</div>
                      <div className="text-sm text-gray-600">Glass-bottomed pool on sun deck</div>
                    </div>
                  </div>
                  <div className="bg-gray-50 p-6 rounded-lg flex items-start gap-4">
                    <i className="ri-check-line text-2xl text-teal-600 mt-1"></i>
                    <div>
                      <div className="font-semibold mb-1">Full-Service Spa</div>
                      <div className="text-sm text-gray-600">With Hammam and beauty therapist</div>
                    </div>
                  </div>
                  <div className="bg-gray-50 p-6 rounded-lg flex items-start gap-4">
                    <i className="ri-check-line text-2xl text-teal-600 mt-1"></i>
                    <div>
                      <div className="font-semibold mb-1">IMAX Dolby Cinema</div>
                      <div className="text-sm text-gray-600">First of its kind on a yacht</div>
                    </div>
                  </div>
                  <div className="bg-gray-50 p-6 rounded-lg flex items-start gap-4">
                    <i className="ri-check-line text-2xl text-teal-600 mt-1"></i>
                    <div>
                      <div className="font-semibold mb-1">Certified Helipad</div>
                      <div className="text-sm text-gray-600">Commercial certification</div>
                    </div>
                  </div>
                  <div className="bg-gray-50 p-6 rounded-lg flex items-start gap-4">
                    <i className="ri-check-line text-2xl text-teal-600 mt-1"></i>
                    <div>
                      <div className="font-semibold mb-1">Basketball Court</div>
                      <div className="text-sm text-gray-600">Multi-sport deck area</div>
                    </div>
                  </div>
                  <div className="bg-gray-50 p-6 rounded-lg flex items-start gap-4">
                    <i className="ri-check-line text-2xl text-teal-600 mt-1"></i>
                    <div>
                      <div className="font-semibold mb-1">Nightclub</div>
                      <div className="text-sm text-gray-600">With interactive dancefloor</div>
                    </div>
                  </div>
                  <div className="bg-gray-50 p-6 rounded-lg flex items-start gap-4">
                    <i className="ri-check-line text-2xl text-teal-600 mt-1"></i>
                    <div>
                      <div className="font-semibold mb-1">Golf Simulator</div>
                      <div className="text-sm text-gray-600">With driving range</div>
                    </div>
                  </div>
                  <div className="bg-gray-50 p-6 rounded-lg flex items-start gap-4">
                    <i className="ri-check-line text-2xl text-teal-600 mt-1"></i>
                    <div>
                      <div className="font-semibold mb-1">Beach Club</div>
                      <div className="text-sm text-gray-600">Direct water access</div>
                    </div>
                  </div>
                </div>
              </div>

              {/* Toys & Tenders */}
              <div>
                <h2 className="text-4xl font-bold mb-6">Toys & Tenders</h2>
                <div className="bg-gray-50 p-8 rounded-lg">
                  <div className="space-y-3 text-gray-700">
                    <div className="flex items-start gap-3">
                      <i className="ri-ship-line text-xl text-teal-600 mt-1"></i>
                      <div>
                        <div className="font-semibold">Tenders</div>
                        <div className="text-sm text-gray-600">LIMO TENDER (10.50m) and OPEN TENDER (10.50m)</div>
                      </div>
                    </div>
                    <div className="flex items-start gap-3">
                      <i className="ri-motorbike-line text-xl text-teal-600 mt-1"></i>
                      <div>
                        <div className="font-semibold">WaveRunners</div>
                        <div className="text-sm text-gray-600">3 x Yamaha FX SVHO WaveRunners</div>
                      </div>
                    </div>
                    <div className="flex items-start gap-3">
                      <i className="ri-water-flash-line text-xl text-teal-600 mt-1"></i>
                      <div>
                        <div className="font-semibold">Seabobs</div>
                        <div className="text-sm text-gray-600">4 x Seabob F5 SR</div>
                      </div>
                    </div>
                    <div className="flex items-start gap-3">
                      <i className="ri-rocket-line text-xl text-teal-600 mt-1"></i>
                      <div>
                        <div className="font-semibold">Flyboard</div>
                        <div className="text-sm text-gray-600">1 x Zapata Racing Flyboard Pro Series</div>
                      </div>
                    </div>
                    <div className="flex items-start gap-3">
                      <i className="ri-surfboard-line text-xl text-teal-600 mt-1"></i>
                      <div>
                        <div className="font-semibold">Water Sports</div>
                        <div className="text-sm text-gray-600">Wakeboards, water skis, stand up paddleboards, kitesurfing equipment</div>
                      </div>
                    </div>
                    <div className="flex items-start gap-3">
                      <i className="ri-anchor-line text-xl text-teal-600 mt-1"></i>
                      <div>
                        <div className="font-semibold">Kayaks</div>
                        <div className="text-sm text-gray-600">2 x Sea Eagle RazorLite inflatable kayaks</div>
                      </div>
                    </div>
                    <div className="flex items-start gap-3">
                      <i className="ri-water-percent-line text-xl text-teal-600 mt-1"></i>
                      <div>
                        <div className="font-semibold">Water Slide</div>
                        <div className="text-sm text-gray-600">17m high water slide</div>
                      </div>
                    </div>
                    <div className="flex items-start gap-3">
                      <i className="ri-basketball-line text-xl text-teal-600 mt-1"></i>
                      <div>
                        <div className="font-semibold">Sports Equipment</div>
                        <div className="text-sm text-gray-600">Foredeck sports court, golf driving mats, fishing gear</div>
                      </div>
                    </div>
                    <div className="flex items-start gap-3">
                      <i className="ri-speed-line text-xl text-teal-600 mt-1"></i>
                      <div>
                        <div className="font-semibold">Electric Boards</div>
                        <div className="text-sm text-gray-600">2 x Awake RÄVIK electric surf boards, 1 x Lift2 Sport eFoil</div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              {/* Charter Destinations */}
              <div>
                <h2 className="text-4xl font-bold mb-6">Charter Destinations</h2>
                <div className="space-y-6">
                  <div className="bg-gradient-to-br from-teal-50 to-blue-50 p-8 rounded-lg">
                    <div className="flex items-start gap-4 mb-4">
                      <i className="ri-map-pin-line text-3xl text-teal-600 mt-1"></i>
                      <div>
                        <h3 className="text-2xl font-bold mb-2">Summer Season (2026)</h3>
                        <p className="text-gray-700 leading-relaxed mb-4">
                          LADY S is available for charter in the Mediterranean during the summer season, offering access to the most exclusive destinations including the French Riviera, Italian coastline, Greek Islands, Croatia, Turkey, and beyond.
                        </p>
                        <div className="flex flex-wrap gap-2">
                          <span className="px-3 py-1 bg-white rounded-full text-sm">French Riviera</span>
                          <span className="px-3 py-1 bg-white rounded-full text-sm">Monaco</span>
                          <span className="px-3 py-1 bg-white rounded-full text-sm">Italian Riviera</span>
                          <span className="px-3 py-1 bg-white rounded-full text-sm">Amalfi Coast</span>
                          <span className="px-3 py-1 bg-white rounded-full text-sm">Greece</span>
                          <span className="px-3 py-1 bg-white rounded-full text-sm">Croatia</span>
                          <span className="px-3 py-1 bg-white rounded-full text-sm">Turkey</span>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="bg-gradient-to-br from-blue-50 to-teal-50 p-8 rounded-lg">
                    <div className="flex items-start gap-4 mb-4">
                      <i className="ri-map-pin-line text-3xl text-teal-600 mt-1"></i>
                      <div>
                        <h3 className="text-2xl font-bold mb-2">Winter Season (2025/2026)</h3>
                        <p className="text-gray-700 leading-relaxed mb-4">
                          Experience the Caribbean and Bahamas aboard LADY S during the winter season, exploring pristine beaches, crystal-clear waters, and exclusive island destinations.
                        </p>
                        <div className="flex flex-wrap gap-2">
                          <span className="px-3 py-1 bg-white rounded-full text-sm">The Bahamas</span>
                          <span className="px-3 py-1 bg-white rounded-full text-sm">Caribbean</span>
                          <span className="px-3 py-1 bg-white rounded-full text-sm">St Lucia</span>
                          <span className="px-3 py-1 bg-white rounded-full text-sm">Barbados</span>
                          <span className="px-3 py-1 bg-white rounded-full text-sm">Grenadines</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              {/* Crew */}
              <div>
                <h2 className="text-4xl font-bold mb-6">Professional Crew</h2>
                <div className="bg-gray-50 p-8 rounded-lg">
                  <div className="flex items-center gap-4 mb-6">
                    <div className="w-16 h-16 bg-teal-500 rounded-full flex items-center justify-center">
                      <i className="ri-team-line text-3xl text-white"></i>
                    </div>
                    <div>
                      <div className="text-2xl font-bold">31 Crew Members</div>
                      <div className="text-gray-600">Highly Experienced & Professional</div>
                    </div>
                  </div>
                  <p className="text-gray-700 leading-relaxed">
                    LADY S accommodates up to 31 crewmembers for the ultimate in luxury service. The highly trained professional crew is dedicated to providing exceptional service throughout your charter. Led by an experienced captain and including skilled chefs, stewardesses, deckhands, engineers, and specialized staff, the crew ensures every aspect of your journey is seamless and memorable. Their attention to detail, discretion, and warm hospitality create an atmosphere of refined luxury.
                  </p>
                </div>
              </div>
            </div>

            {/* Right Column - Sidebar */}
            <div className="lg:col-span-1">
              <div className="sticky top-24 space-y-6">
                {/* Charter Rates */}
                <div className="bg-gradient-to-br from-teal-500 to-teal-600 text-white p-8 rounded-lg">
                  <h3 className="text-2xl font-bold mb-6">Charter Rates</h3>
                  <div className="space-y-4">
                    <div className="border-b border-white/20 pb-4">
                      <div className="text-sm opacity-90 mb-1">Summer 2026</div>
                      <div className="text-3xl font-bold">€1,750,000</div>
                      <div className="text-sm opacity-90">per week + expenses</div>
                    </div>
                    <div className="pb-4">
                      <div className="text-sm opacity-90 mb-1">Winter 2025/2026</div>
                      <div className="text-3xl font-bold">€1,600,000</div>
                      <div className="text-sm opacity-90">per week + expenses</div>
                    </div>
                  </div>
                  <button
                    onClick={scrollToInquiry}
                    className="w-full bg-white text-teal-600 py-3 rounded-lg font-semibold hover:bg-gray-100 transition-all mt-6 whitespace-nowrap cursor-pointer"
                  >
                    Request Charter Quote
                  </button>
                </div>

                {/* Quick Facts */}
                <div className="bg-gray-50 p-6 rounded-lg">
                  <h3 className="text-xl font-bold mb-4">Quick Facts</h3>
                  <div className="space-y-3 text-sm">
                    <div className="flex justify-between py-2 border-b border-gray-200">
                      <span className="text-gray-600">Builder</span>
                      <span className="font-semibold">Feadship</span>
                    </div>
                    <div className="flex justify-between py-2 border-b border-gray-200">
                      <span className="text-gray-600">Year</span>
                      <span className="font-semibold">2019</span>
                    </div>
                    <div className="flex justify-between py-2 border-b border-gray-200">
                      <span className="text-gray-600">Length</span>
                      <span className="font-semibold">93m / 305ft</span>
                    </div>
                    <div className="flex justify-between py-2 border-b border-gray-200">
                      <span className="text-gray-600">Guests</span>
                      <span className="font-semibold">12</span>
                    </div>
                    <div className="flex justify-between py-2 border-b border-gray-200">
                      <span className="text-gray-600">Cabins</span>
                      <span className="font-semibold">7</span>
                    </div>
                    <div className="flex justify-between py-2">
                      <span className="text-gray-600">Crew</span>
                      <span className="font-semibold">31</span>
                    </div>
                  </div>
                </div>

                {/* Contact Broker */}
                <div className="bg-gray-900 text-white p-6 rounded-lg">
                  <h3 className="text-xl font-bold mb-4">Contact Broker</h3>
                  <p className="text-sm text-gray-300 mb-6">
                    Speak with our charter specialists to discuss availability, itineraries, and special requests.
                  </p>
                  <button
                    onClick={scrollToInquiry}
                    className="w-full bg-teal-500 hover:bg-teal-600 text-white py-3 rounded-lg font-semibold transition-all whitespace-nowrap cursor-pointer"
                  >
                    Contact Us
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Charter Inquiry Form */}
      <section id="inquiry-form" className="py-20 bg-gray-50">
        <div className="max-w-4xl mx-auto px-6">
          <div className="text-center mb-12">
            <h2 className="text-4xl font-bold mb-4">Request Charter Information</h2>
            <p className="text-xl text-gray-600">
              Complete the form below and our charter specialists will contact you within 24 hours
            </p>
          </div>
          
          <div className="bg-white p-8 rounded-lg shadow-lg">
            {submitStatus === 'success' ? (
              <div className="py-12 text-center">
                <i className="ri-check-line text-5xl text-green-600 mb-4"></i>
                <p className="text-lg">Thank you for your inquiry. We'll be in touch shortly.</p>
              </div>
            ) : (
              <form onSubmit={handleSubmit} data-readdy-form id="lady-s-charter-inquiry-form">
                <div className="space-y-6">
                  <div>
                    <label className="block text-xs tracking-wider mb-2">NAME *</label>
                    <input
                      type="text"
                      name="name"
                      required
                      value={formData.name}
                      onChange={(e) => setFormData({ ...formData, name: e.target.value })}
                      className="w-full px-4 py-3 text-sm border border-gray-300 focus:outline-none focus:border-black transition-colors cursor-text"
                    />
                  </div>

                  <div>
                    <label className="block text-xs tracking-wider mb-2">EMAIL *</label>
                    <input
                      type="email"
                      name="email"
                      required
                      value={formData.email}
                      onChange={(e) => setFormData({ ...formData, email: e.target.value })}
                      className="w-full px-4 py-3 text-sm border border-gray-300 focus:outline-none focus:border-black transition-colors cursor-text"
                    />
                  </div>

                  <div>
                    <label className="block text-xs tracking-wider mb-2">PHONE</label>
                    <input
                      type="tel"
                      name="phone"
                      value={formData.phone}
                      onChange={(e) => setFormData({ ...formData, phone: e.target.value })}
                      className="w-full px-4 py-3 text-sm border border-gray-300 focus:outline-none focus:border-black transition-colors cursor-text"
                    />
                  </div>

                  <div>
                    <label className="block text-xs tracking-wider mb-2">PREFERRED DATES</label>
                    <input
                      type="text"
                      name="preferredDates"
                      placeholder="e.g., July 15-22, 2026"
                      value={formData.preferredDates}
                      onChange={(e) => setFormData({ ...formData, preferredDates: e.target.value })}
                      className="w-full px-4 py-3 text-sm border border-gray-300 focus:outline-none focus:border-black transition-colors cursor-text"
                    />
                  </div>

                  <div>
                    <label className="block text-xs tracking-wider mb-2">DESTINATION</label>
                    <input
                      type="text"
                      name="destination"
                      value={formData.destination}
                      onChange={(e) => setFormData({ ...formData, destination: e.target.value })}
                      className="w-full px-4 py-3 text-sm border border-gray-300 focus:outline-none focus:border-black transition-colors cursor-text"
                    />
                  </div>

                  <div>
                    <label className="block text-xs tracking-wider mb-2">NUMBER OF GUESTS</label>
                    <input
                      type="number"
                      name="guests"
                      min="1"
                      max="12"
                      value={formData.guests}
                      onChange={(e) => setFormData({ ...formData, guests: e.target.value })}
                      className="w-full px-4 py-3 text-sm border border-gray-300 focus:outline-none focus:border-black transition-colors cursor-text"
                    />
                  </div>

                  <div>
                    <label className="block text-xs tracking-wider mb-2">MESSAGE</label>
                    <textarea
                      name="message"
                      rows={4}
                      maxLength={500}
                      value={formData.message}
                      onChange={(e) => setFormData({ ...formData, message: e.target.value })}
                      className="w-full px-4 py-3 text-sm border border-gray-300 focus:outline-none focus:border-black transition-colors resize-none cursor-text"
                    ></textarea>
                    <p className="text-xs text-gray-500 mt-1">{formData.message.length}/500 characters</p>
                  </div>

                  {submitStatus === 'error' && (
                    <div className="p-4 bg-red-50 border border-red-200">
                      <p className="text-sm text-red-600">There was an error submitting your inquiry. Please try again.</p>
                    </div>
                  )}

                  <button
                    type="submit"
                    disabled={isSubmitting}
                    className="w-full px-6 py-4 bg-black text-white text-sm tracking-wider hover:bg-gray-800 transition-colors whitespace-nowrap cursor-pointer disabled:opacity-50 disabled:cursor-not-allowed"
                  >
                    {isSubmitting ? 'SUBMITTING...' : 'SUBMIT INQUIRY'}
                  </button>
                </div>
              </form>
            )}
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}
